import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/components/shared.module';
import { MedicalFeeControlFilterComponent } from '../medical-fee-control-filter/medical-fee-control-filter.component';
import { MedicalFeeControlSearchComponent } from './medical-fee-control-search.component';
import { NoMedicalFeeReasonDialogComponent } from '../../dialogs/no-medical-fee-reason-dialog/no-medical-fee-reason-dialog.component';

@NgModule({
  declarations: [
    MedicalFeeControlFilterComponent,
    MedicalFeeControlSearchComponent,
    NoMedicalFeeReasonDialogComponent
  ],
  imports: [
    ReactiveFormsModule,
    SharedModule
  ],
  entryComponents: [
    NoMedicalFeeReasonDialogComponent
  ]
})
export class MedicalFeeControlSearchModule { }
